import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

import './App.css';

function App(props) {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [selectedField, setSelectedField] = useState('Consultant');
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState(false);

  // sessionStorage.setItem("isAdmin", false);

  useEffect(() => {
    if (sessionStorage.getItem("isAdmin") == "true") {
      setAdmin(true)

    }

  }, [])



  useEffect(() => {
    fetch('http://crm.arunexcello.com:3000/getalldata')
      .then((res) => res.json())
      .then((res) => {
        setData(res);
        setLoading(false);
      });
  }, []);

  function handleDataUpdate(data) {
    props.setSelectedContact(data);
    navigate("/update")
  }

  function handleDataDelete(id) {
    axios
      .delete("http://crm.arunexcello.com:3000/remove/" + id)
      .then(() => {
        // console.log("Successfully deleted")
        setData(data.filter((item) => item._id !== id));
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const fieldNames = Array.from(new Set(data.map((item) => item.FIELD)));
  const filteredData = data.filter((item) => item.FIELD === selectedField);

  const handleChange = (event) => {
    setSelectedField(event.target.value);
  };

  return (
    <>
      {loading ? (
        <p id='loading'>Loading<span className="loader__dot">.</span>
          <span className="loader__dot">..</span></p>
      ) : (
        <>
          <div className='selector'>
            <div htmlFor='field-select'>Filter by:</div>
            <select id='field-select' value={selectedField} onChange={handleChange}>
              {fieldNames.map((fieldName) => (
                <option key={fieldName} value={fieldName}>
                  {fieldName}
                </option>
              ))}
            </select>
          </div>

          <div id='tablediv'>
            <table>
              <thead>

                <tr>
                  {admin ? (
                    <th id='actionsth'>Actions</th>
                  ) : null}
                  <th id='headth'>FIELD</th>
                  <th id='headth'>Name</th>
                  <th id='headth'>Company</th>
                  <th id='headth'>Job Title</th>
                  <th id='headth'>Address</th>
                  <th id='headth'>Phone Numbers</th>
                  <th id='headth'>Email</th>
                  <th id='headth'>Websites</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    {admin ? (
                      <td> <span id='updateicon' onClick={() => { handleDataUpdate(item) }} >  UPDATE </span> <br /><span id='deleteicon' onClick={() => { handleDataDelete(item._id) }}> DELETE </span></td>
                    ) : null}
                    <td>{item.FIELD}</td>
                    <td>{item.Name}</td>
                    <td>{item.Company}</td>
                    <td>{item['Job Title']}</td>
                    <td>{item.Address}</td>
                    <td>{item['Phone Number']}</td>
                    <td>{item['Email']}</td>
                    <td>{item.Websites}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default App;
